function toggleScrollerNav(swiper) {
  var wrapper = swiper.el.closest('[data-section="before-after-scroller"]');
  if (!wrapper) return;

  var slideCount = parseInt(wrapper.getAttribute('data-slide-count'), 10);
  var needsNav = slideCount > swiper.params.slidesPerView;

  wrapper.querySelectorAll('.hoox-swiper-arrow').forEach(function (arrow) {
    arrow.style.display = needsNav ? '' : 'none';
    arrow.setAttribute('aria-hidden', needsNav ? 'false' : 'true');
    arrow.setAttribute('tabindex', needsNav ? '0' : '-1');
  });

  var dotsRow = wrapper.querySelector('.hoox-reviews__arrows');
  if (dotsRow) dotsRow.style.display = needsNav ? '' : 'none';

  if (needsNav) {
    swiper.enable();
  } else {
    swiper.disable();
  }
}

var hooxSliderReviews1 = document.querySelector(".hoox-reviews__slider-reviews");

if (hooxSliderReviews1) {
  var sectionScope = '[data-section="before-after-scroller"]';
  var slider1 = new Swiper(hooxSliderReviews1, {
    rewind: true,
    slidesPerView: 1,
    breakpoints: {
      767: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
    pagination: {
      el: sectionScope + ' .hoox-reviews__dots',
      clickable: true,
    },
    navigation: {
      nextEl: sectionScope + ' .hoox-swiper-arrow-next',
      prevEl: sectionScope + ' .hoox-swiper-arrow-prev',
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    on: {
      init: function () { toggleScrollerNav(this); },
      breakpoint: function () { toggleScrollerNav(this); },
    },
  });
}

var hooxSliderReviews2 = document.querySelector(".hoox-reviews__slider-reviewscontourreviews");

if (hooxSliderReviews2) {
  var slider2 = new Swiper(hooxSliderReviews2, {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    breakpoints: {
      767: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    },
    pagination: {
      el: '.hoox-reviews__dots',
      clickable: true,
    },
    navigation: {
      nextEl: ".hoox-swiper-arrow-next",
      prevEl: ".hoox-swiper-arrow-prev",
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
  });
}
